import type { TFunction } from "i18next";

/**
 * The elastic schedule's units (owner, 2026-10-24): how many of each fit in a day. The period is kept in days
 * (`rec.periodDays`, what the want bar is computed from) and the unit beside it (`rec.periodUnit`) only for
 * showing it again: a week is 7 days, a month 30.
 */
export const PERIOD_UNITS = { minutes: 1440, hours: 24, days: 1, weeks: 1 / 7, months: 1 / 30 } as const;
export type PeriodUnit = keyof typeof PERIOD_UNITS;

export const isPeriodUnit = (u: unknown): u is PeriodUnit => typeof u === "string" && u in PERIOD_UNITS;

/** The period in its unit, to two decimals. */
export const periodIn = (days: number, unit: PeriodUnit) => Math.round(days * PERIOD_UNITS[unit] * 100) / 100;

/** "3 weeks", "90 minutes": the period as the person set it (days when no unit is stored). */
export function formatPeriod(t: TFunction, days: number, unit: unknown): string {
  const u = isPeriodUnit(unit) ? unit : "days";
  const n = periodIn(days, u);
  return `${n} ${t(`repeat.units.${u}`, { count: n })}`;
}
